'use strict';

var DetailsLengthOfStayGridDirective = function DetailsLengthOfStayGridDirective(pricingAnalysisCommonsDataService) {
  return {
    restrict: 'E',
    template: require('../templates/details-length-of-stay-grid.html'),
    replace: true,
    controller: 'DetailsLengthOfStayGridController',
    link: function link(scope) {
      scope.$on('chart:lengthOfStay:selected', function (evt, referenceService, originalService) {
        scope.retrieveData(referenceService, originalService);
      });
      scope.$on('chart:services:selectedService', function (evt, originalService) {
        if (pricingAnalysisCommonsDataService.isSingleItinerary(originalService)) {
          scope.retrieveData(null, originalService);
        }
      });
    }
  };
};
DetailsLengthOfStayGridDirective.$inject = ['PricingAnalysisCommonsDataService'];
module.exports = DetailsLengthOfStayGridDirective;